// extracted by mini-css-extract-plugin
export default {"container":"SettingsSwiper_container__-mrKb"};